<template>
  <div class="auth-form-modal">
    <AuthLoadingModal />

    <nav class="tab-nav">
      <button
        class="tab-btn"
        :class="{active: currentTab == 'sign-in'}"
        @click="changeTab('sign-in')"
      >Entrar</button>

      <button
        class="tab-btn"
        :class="{active: currentTab == 'sign-up'}"
        @click="changeTab('sign-up')"
      >Criar conta</button>
    </nav>

    <div class="tab-content">
      <AlertBox
        :type="alertBoxType"
        v-if="isAlertBoxVisible"
      >{{ alertBoxMessage }}</AlertBox>

      <SignInTabModal @close="$emit('close')" v-if="currentTab == 'sign-in'" />

      <SignUpTabModal v-if="currentTab == 'sign-up'" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import SignInTabModal from './SignInTabModal'
  import SignUpTabModal from './SignUpTabModal'
  import AuthLoadingModal from './AuthLoadingModal'
  import AlertBox from '@/components/layout/AlertBox'

  export default {
    components: {
      SignInTabModal,
      SignUpTabModal,
      AuthLoadingModal,
      AlertBox
    },

    props: ['defaultTab'],

    data: () => ({
      currentTab: null
    }),

    mounted () {
      this.currentTab = this.defaultTab || 'sign-in'
    },

    computed: {
      ...mapState('auth', ['hasError', 'hasSuccess']),

      isAlertBoxVisible () {
        return !!this.hasError || !!this.hasSuccess
      },

      alertBoxMessage () {
        return this.hasError || this.hasSuccess
      },

      alertBoxType () {
        return this.hasError ? 'danger' : 'info'
      }
    },

    methods: {
      changeTab (tab) {
        this.$store.commit('auth/setError', '')
        this.currentTab = tab
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .auth-form-modal {
    position: relative;
    background-color: $sectionContainerGrayBg;
    padding: 1.3rem;
    color: $white300;

    .tab-nav {
      display: flex;
      justify-content: space-between;

      .tab-btn {
        flex: 1;
        height: 50px;
        font-size: 18px;
        font-weight: 500;
        color: $textPrimaryColor;
        text-align: center;
        border-bottom: 2px solid transparent;

        &.active {
          color: $highlightPrimaryColor;
          border-color: $highlightPrimaryColor;
        }
      }
    }

    .tab-content {
      padding-top: 1.3rem;
    }
  }
</style>